// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { ReactNode, useState } from 'react'
import { Aside } from '@teamnine/pcj-ui-v2'

import SideNavContent from './SideNavContent'
import * as Styled from './Styles'

export type SideNavProps = {
  isCollapsed: boolean
  handleCollapse: (arg: boolean) => void
  children?: ReactNode
}

export default function SideNav({
  isCollapsed,
  handleCollapse,
  children,
}: SideNavProps) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)

  return (
    <Aside open={isMobileNavOpen} onOpenChange={setIsMobileNavOpen}>
      {children}
      <Styled.Display aria-label="Navigation">
        <Styled.Content>
          <SideNavContent
            isCollapsed={isCollapsed}
            handleCollapse={handleCollapse}
            onNavigate={() => setIsMobileNavOpen(false)}
          />
        </Styled.Content>
      </Styled.Display>
    </Aside>
  )
}
